import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { LetterrequestcustomerRelativeService } from 'src/app/Service/Letter/LetterrequestcustomerRelative.service';


@Component({
  selector: 'app-LetterrequestcustomerRelativeForm',
  templateUrl: './LetterrequestcustomerRelativeForm.component.html',
  styleUrls: ['./LetterrequestcustomerRelativeForm.component.scss']
})
export class LetterrequestcustomerRelativeFormComponent implements OnInit {

  @Input() inner_Letter:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()
  @Output() OnBack_LetterrequestcustomerRelative_Action = new EventEmitter<number>();
  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private LetterrequestcustomerRelative_Service:LetterrequestcustomerRelativeService,
    private Alertify_Service:AlertifyService,
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
  ) { }


  DataList_LetterrequestcustomerRelative:Array<General_Interface>=[]


  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.ReadData_LetterrequestcustomerRelative()

    
  }

  ReadData_LetterrequestcustomerRelative(){
    this.Procssing=true
    this.LetterrequestcustomerRelative_Service.GetCustomer(this.Token,this.inner_Letter.id).subscribe(
      data=>{
        this.DataList_LetterrequestcustomerRelative=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  Set_Selected_Customer_Record(item:Customer_List_Interface) {
    
    this.modalRef_Customer.hide()
    this.Procssing=true
    this.LetterrequestcustomerRelative_Service.Add(this.Token,item.id,this.inner_Letter.id).subscribe(
      data=>{
        this.Procssing=false
        if(data['id']==-1)
        {
          this.Alertify_Service.ErrorMessage("The customer has already been selected.")
        }
        else{
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
          this.ReadData_LetterrequestcustomerRelative()
        }
      }
    )
  }

  DeleteData(item:General_Interface) {
    this.Procssing=true
    this.LetterrequestcustomerRelative_Service.Delete(this.Token,item.id).subscribe(
      data=>{
        this.Procssing=false
        this.Alertify_Service.SuccessMessage("Information deleted successfully.")
        this.ReadData_LetterrequestcustomerRelative()
      }
    )
  }

  
  OnSet_Back_LetterrequestcustomerRelativeList() {
    this.OnBack_LetterrequestcustomerRelative_Action.emit(-1);

  }

  //#region Customer

  modalRef_Customer: any;
  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }


  ReadData_Customer_KeySearch_Timer: any
  ReadData_Customer_KeySearch() {

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Customer()
    }.bind(this), 1000);

  }

  Search_CodeName_Customer_Table: string = ''
  DataList_Customer: Array<Customer_List_Interface> = []
  ProcssingCustomer:boolean=false
  ReadData_Customer() {

    if (!this.Search_CodeName_Customer_Table) {
      this.DataList_Customer = []
    }
    else {


      this.ProcssingCustomer = true
      this.Customer_Service.GetSearchCalibration(this.Token, this.Search_CodeName_Customer_Table).subscribe(
        data => {
          this.DataList_Customer = data
          this.ProcssingCustomer = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  //#endregion


}
